<template>
  <div
    class="main-container blog_page"
    style="background: #FAFAFA;padding-top:30px"
  >
    <div class="white_bg">
      <HeaderDefault />
    </div>
    <!-- blog item wrapper start -->
    <div
      class="blog-pages-wrapper"
      style="margin-top:0px;background-color:rgb(246,245,249);padding:15px 0 40px 0;"
    >
      <div
        class="main-blog-wrap"
        style="width:100%;max-width:900px;display:block;margin: -120px auto 0 auto;"
      >
        <div
          style="padding:10px 40px 10px 40px;background-color:white;margin-top:200px;border-radius:12px;"
          class="sheet padding-5mm"
        >
          <!--======= Single Blog Item Start ========-->
          <div class="single-blog-item">
            <div
              style="width:100%;display:block;margin: 20px auto 20px auto;"
              v-if="loading"
            >
              <!-- <b-spinner
                label="Spinning"
                style="margin: 40px auto 40px auto;"
              ></b-spinner> -->
              <Skeleton :width="'100%'" :height="'60px'" />
              <Skeleton :width="'40%'" :height="'20px'" />
              <Skeleton :width="'100%'" :height="'300px'" />
              <Skeleton :width="'50%'" :height="'20px'" :count="4" />
              <Skeleton :width="'70%'" :height="'20px'" :count="4" />
              <Skeleton :width="'20%'" :height="'20px'" :count="4" />
              <Skeleton :width="'100%'" :height="'20px'" :count="4" />
              <Skeleton :width="'80%'" :height="'20px'" :count="4" />
            </div>
            <!-- Post info Start -->
            <div v-else class="post-info lg-blog-post-info wow move-up">
              <h2
                class="post-title mb-3 mt-4"
                style="font-size:2.4rem;line-height:3.2rem;font-family:Roboto"
              >
                {{ blog.publicTitle }}
              </h2>

              <div
                class="post-meta mb-2 ml-0"
                style="margin-top:-5px;font-size:0.9rem;"
              >
                <div class="post-date">
                  <span class="far fa-calendar meta-icon"></span>
                  {{ formatTimeShort(blog.dateCreated) }}
                  <span class="far fa-eye meta-icon mr-2 ml-5"></span>
                  <span>{{ blog.viewCount }}</span>
                </div>
              </div>

              <h4
                class="editor_result_content mb-4"
                v-if="blog.publicHeadline"
                v-html="blog.publicHeadline"
              ></h4>

              <div
                class="editor_result_content mt-3 mb-5"
                v-html="blog.publicDetail"
              ></div>
            </div>
            <!-- Post info End -->
          </div>
          <!--===== Single Blog Item End =========-->
        </div>
      </div>
    </div>
    <!-- blog item wrapper end -->
    <FooterMain />
  </div>
</template>

<script>
import FooterMain from "@/components/FooterMain";
import HeaderDefault from "@/components/sections/HeaderDefault";
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    HeaderDefault,
    FooterMain,
    Skeleton,
  },
  data() {
    return {
      blog: {},
      loading: true,
    };
  },
  async created() {
    await this.ping();
    await this.render();
    this.scrollToTop();
  },
  methods: {
    async render() {
      var id = this.$route.params.id;
      this.loading = true;
      var result = await this.$httpClient.get(`/public/episode/${id}`);
      if (!result || result.error) {
        this.$router.push("/404");
      }
      this.loading = false;
      this.blog = result;
    },
  },
};
</script>

<style lang="scss">
.white_bg {
  .header-area {
    background: rgb(246, 245, 249);
  }
}
</style>
